import React, {Component} from 'react';
import PropTypes from 'prop-types';
import $ from "jquery";

/**
 * creat by tianruojun
 * @description 手写的文本域
 * @class RmtTextArea
 * @extends {Component}
 */
export default class RmtTextArea extends Component {
    static propTypes = {
        /**
         * @text 初始部门id
         * @category data
         */
        deptId: PropTypes.string,
        /**
         * @text 点击弹窗确认按钮后的回调
         * @category event
         */
        onSelect: PropTypes.func
    };
    static defaultProps = {
        onInput: (e) => {
        },
        onBlur: (e) => {
        },
        disabled: false,
        style: {},
    };

    /**
     * 处理睡觉的回调
     * @param {string} name 姓名
     */
    onSleep = (name) => {
        this.setState({name})
    };

    constructor(props) {
        super(props);
        this.state = {
            lastContent: this.replaceBr(this.props.content)
        }
        let agent = window.navigator.userAgent.toLocaleLowerCase()
        this.browser = {
            ie: /(msie\s|trident.*rv:)([\w.]+)/.test(agent),
        }
        this.fillChar = this.browser.ie ? '\ufeff' : '\u200B';
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.content !== this.textArea.innerHTML;
    }

    componentDidUpdate() {
        if (this.props.content !== this.textArea.innerHTML) {
            this.textArea.innerHTML = this.replaceBr(this.props.content);
        }
    }

    onChange = (e) => {
        console.log("ref",this.textArea);
        console.log("html",e.target.innerHTML);
        console.log("txt",e.target.innerText);
        const html = this.textArea.innerHTML;
        if (this.props.onChange && html !== this.state.lastContent) {
            this.props.onChange(html,e);
            this.state.lastContent = html;
        }
    };

    replaceBr = (html) => {
        if(html.indexOf('<div>')===-1) {
            return `<div>${html}</div>`;
        }
        return html
        // return html.replace(/\/n/g,'<br>')
    };

    getContent = () => {
        return  this.textArea&&this.textArea.innerHTML
    }

    textAreaDivRef = () => {
        return  this.textArea
    }

    getInnerTxt = () => {
        let reg = new RegExp(this.fillChar,"g")
        let html = this.textArea.innerHTML;
        let txt = "";
        if (html && html.indexOf("<style>") > -1) {
            html = html.replace(/<style[^>]*>[^<]*<\/style>/g,"")
        }
        txt = $(`<div>${html}</div>`).text();
        return txt.replace(reg, "").replace(/\u00a0/g, " ");
    }

    getContentTxt = () => {
        let reg = new RegExp(this.fillChar,"g")
        return this.textArea[this.browser.ie? "innerText" : 'textContent'].replace(reg,"").replace(/\u00a0/g, " ")
    }

    render() {
        const {disabled,style,content,className=""} = this.props;
        let {lastContent} = this.state;
        return (
            <div
                ref={a=>{
                    this.textArea = a;
                }}
                className={className}
                disabled={disabled}
                id={"TextArea"}
                onInput={(e)=>{this.onChange(e)}}
                onBlur={(e)=>{this.onChange(e)}}
                style={{
                    minHeight: 70,
                    lineHeight: "24px",
                    border: 'none',
                    resize: 'none',
                    outline: 'none',
                    padding: "4px 11px",
                    // whiteSpace:'pre-line',
                    // whiteSpace:'pre',
                    backgroundColor: 'rgba(0,80,179,0.04)',
                    whiteSpace: 'break-spaces',
                    ...style
                }}
                contentEditable="true"
                suppressContentEditableWarning
                type='customTextarea'
                spellCheck="false"
                dangerouslySetInnerHTML={{__html:lastContent}}
            >
            </div>
        )
    }

}